import React from 'react';
import { Box, Typography, Link } from '@mui/material';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: '#CABFB4',
        color: '#000',
        py: 2,
        px: 3,
        textAlign: 'center',
        borderTop: '1px solid rgba(0, 0, 0, 0.12)',
        zIndex: 1100,
      }}
    >
      <Typography variant="body2" sx={{ display: 'inline' }}>
        Copyright &copy; 2026 Cheese Press Publishing. All rights reserved.
      </Typography>
      <Link
        href="mailto:support@cheesepresspublishing.com"
        color="inherit"
        variant="body2"
        sx={{
          ml: 1,
          textDecoration: 'underline',
          display: 'inline'
        }}
      >
        support@cheesepresspublishing.com
      </Link>
    </Box>
  );
};

export default Footer;
